<script>
	import TileInputController from './TileInputController.svelte';
	import GameTilesController from './GameTilesController.svelte';
</script>

<main>
	<GameTilesController />
	<TileInputController />
</main>

<style>
	main {
		max-width: none;
		height: 100vh;
	}
</style>